// src/services/EmployeeTaskService.js

import API from './api';

// Employee Task API Service
const EmployeeTaskService = {
  // Get all tasks
  getAllTasks: async () => {
    try {
      const res = await API.get('/api/tasks');
      return res.data;
    } catch (error) {
      console.error('Error getting all tasks:', error.response?.data || error.message);
      throw error;
    }
  },

  // Get task by ID
  getTaskById: async (taskId) => {
    try {
      const res = await API.get(`/api/tasks/${taskId}`);
      return res.data;
    } catch (error) {
      console.error('Error getting task:', error.response?.data || error.message);
      throw error;
    }
  },

  // Create new task
  createTask: async (taskData) => {
    try {
      const res = await API.post('/api/tasks', taskData);
      return res.data;
    } catch (error) {
      console.error('Error creating task:', error.response?.data || error.message);
      throw error;
    }
  },

  // Update task
  updateTask: async (taskId, taskData) => {
    try {
      const res = await API.put(`/api/tasks/${taskId}`, taskData);
      return res.data;
    } catch (error) {
      console.error('Error updating task:', error.response?.data || error.message);
      throw error;
    }
  },

  // Delete task
  deleteTask: async (taskId) => {
    try {
      const res = await API.delete(`/api/tasks/${taskId}`);
      return res.data;
    } catch (error) {
      console.error('Error deleting task:', error.response?.data || error.message);
      throw error;
    }
  },

  // Update task status
  updateTaskStatus: async (taskId, status, completedAt = null) => {
    try {
      const updateData = { status };
      if (status === 'completed' && completedAt) {
        updateData.completedAt = completedAt;
      }
      const res = await API.put(`/api/tasks/${taskId}`, updateData);
      return res.data;
    } catch (error) {
      console.error('Error updating task status:', error.response?.data || error.message);
      throw error;
    }
  },

  // Add comment to task
  addComment: async (taskId, comment, userId) => {
    try {
      // Get current task first
      const currentTask = await API.get(`/api/tasks/${taskId}`);
      const updatedComments = [
        ...(currentTask.data.comments || []),
        {
          user: userId,
          comment: comment,
          createdAt: new Date()
        }
      ];
      
      const res = await API.put(`/api/tasks/${taskId}`, {
        comments: updatedComments
      });
      return res.data;
    } catch (error) {
      console.error('Error adding comment:', error.response?.data || error.message);
      throw error;
    }
  },

  // Get tasks by employee ID
  getTasksByEmployee: async (employeeId) => {
    try {
      const res = await API.get('/api/tasks');
      // Filter tasks by assignedTo on frontend
      return res.data.filter(task => task.assignedTo === employeeId);
    } catch (error) {
      console.error('Error getting employee tasks:', error.response?.data || error.message);
      throw error;
    }
  },

  // Get tasks by status
  getTasksByStatus: async (status) => {
    try {
      const res = await API.get('/api/tasks');
      // Filter tasks by status on frontend
      return res.data.filter(task => task.status === status);
    } catch (error) {
      console.error('Error getting tasks by status:', error.response?.data || error.message);
      throw error;
    }
  },

  // Get tasks by priority
  getTasksByPriority: async (priority) => {
    try {
      const res = await API.get('/api/tasks');
      // Filter tasks by priority on frontend
      return res.data.filter(task => task.priority === priority);
    } catch (error) {
      console.error('Error getting tasks by priority:', error.response?.data || error.message);
      throw error;
    }
  },

  // Get overdue tasks
  getOverdueTasks: async () => {
    try {
      const res = await API.get('/api/tasks');
      const currentDate = new Date();
      return res.data.filter(task => 
        task.dueDate && 
        new Date(task.dueDate) < currentDate && 
        task.status !== 'completed'
      );
    } catch (error) {
      console.error('Error getting overdue tasks:', error.response?.data || error.message);
      throw error;
    }
  }
};

export default EmployeeTaskService;